import { render, staticRenderFns } from "./GroupEmpty.vue?vue&type=template&id=6bb8e451&"
import script from "./GroupEmpty.vue?vue&type=script&lang=ts&"
export * from "./GroupEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports